module.exports = __webpack_public_path__ + "img/login_taoyu2.e9afd112.png";